import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

// Suppress unactionable cross-origin "Script error." noise. The browser emits
// this generic message (no filename, no line number) when any cross-origin
// script throws and the server doesn't return CORS headers — GTM/gtag load
// their own internal scripts without CORS, so these leak through even though
// the GTM loader tag itself has crossOrigin='anonymous'. The message carries
// no information we can act on, so filter it at the window level before any
// error reporting surfaces it. Real app errors (which always carry a
// filename + line number) pass through unchanged.
if (typeof window !== 'undefined') {
  const isCrossOriginScriptError = (msg, url, line) =>
    (msg === 'Script error.' || msg === 'Script error') && (!url || !line || line === 0);
  window.addEventListener('error', (e) => {
    if (isCrossOriginScriptError(e.message, e.filename, e.lineno)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  }, true);
  const origOnError = window.onerror;
  window.onerror = function (msg, url, line, col, err) {
    if (isCrossOriginScriptError(msg, url, line)) return true;
    return origOnError ? origOnError.apply(this, arguments) : false;
  };
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    if (r && typeof r === 'object' && (r.message === 'Script error.' || r.message === 'Script error')) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)